import * as React from 'react';
import { CheckBoxComponent } from '.';
import { ISearchData } from '../../models';
import styles from './GenerateCheckboxes.module.scss';

interface IGenerateCheckboxesProps {
    searchData: ISearchData[];
    title: string;
}

interface IGenerateCheckboxesStatus {
    itemsToShow: number;
    expanded: boolean;
    data: ISearchData[];
}

export class GenerateCheckboxes extends React.Component<IGenerateCheckboxesProps, IGenerateCheckboxesStatus> {

    private defaultItems: number = 5;

    constructor(props: IGenerateCheckboxesProps) {
        super(props);

        // For the generation of the Document Type checkboxes - see if we already have some checked - 
        // If not pre-check all the Document Type checkboxes except for the "Form" one. 
        if (this.props.title == 'Document Type') {
            var documentType: string[] = JSON.parse(localStorage.getItem('documentType') || '');

            if (documentType.length == 0) {

                for(var i = 0;i<this.props.searchData.length;i++) { 
                    if(this.props.searchData[i].value !== 'Form') {
                        documentType.push(this.props.searchData[i].value);
                    }
                 }

            }
            localStorage.setItem("documentType", JSON.stringify(documentType));           

        }


        this.state = {
            itemsToShow: this.defaultItems,
            expanded: false,
            data: this.props.searchData
        }
    }


    componentDidUpdate(prevProps: IGenerateCheckboxesProps, prevState: IGenerateCheckboxesStatus) {
        if (prevState.expanded != this.state.expanded) {
            this.render();
        }
    }


    public render() {
        return (
            <>
                {this.data()}
                <a className={styles.showMore} onClick={() => this.showMore()}>
                    {this.state.expanded ? (
                        <span>Show less</span>
                    ) : (
                        <span>Show more</span>
                    )}
                </a>
            </>)
    }

    private data() {
        return this.state.data.slice(0, this.state.itemsToShow).map((sd, i) => {
            return (
                <CheckBoxComponent key={i} item={sd.text} title={this.props.title} isChecked={this.isChecked(sd.value)} />
            );
        });
    }

    private showMore() {
        this.state.itemsToShow === this.defaultItems ? (
            this.setState({ itemsToShow: this.state.data.length, expanded: true })
        ) : (
            this.setState({ itemsToShow: this.defaultItems, expanded: false })
        )
    }

    private isChecked(text: string) {
        if (this.props.title == 'Division') {
            var division: string[] = JSON.parse(localStorage.getItem('division') || '');
            if (division.indexOf(text) !== -1) {
                return true;
            }
        }

        if (this.props.title == 'Document Type') {
            var documentType: string[] = JSON.parse(localStorage.getItem('documentType') || '');
            if (documentType.indexOf(text) !== -1) {
                return true;
            }
        }

        return false;
    }
}